import gql from 'graphql-tag'

export const GET_ENTITY_QUERY = gql`
  query entity($id: ID!) {
    entity(id: $id) @rest(type: "Entity", path: "/entity/{args.id}") {
      id
      entity_type_id
      name
      attributes
      geom
      tree_path
      group {
        id
        name
      }
      entity_type {
        id
        tenant_id
        name
        category
        definition
        attributes_order
        attributes
      }
      level
      children
    }
  }
`
